var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"m-0",attrs:{"title":"User Analytics"}},[_c('app-timeline')],1)}
var staticRenderFns = []

export { render, staticRenderFns }